import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isVideo',
    standalone: true
})
export class IsVideoPipe implements PipeTransform {

    transform(value: any): boolean {
        return ['mp4', 'webm', 'video'].includes(value?.type);
    }

}
